import { createSelector } from '@ngrx/store';
import { UserState } from '../state/user.state';
import { AppState } from '@store/state/app.state';
import { Alert } from '@models/alerts';
import { getFavoriteMarkets } from './market.selector';

const selectUser = (state: AppState): UserState => state.user;

export const getLoggedUser = createSelector(
    selectUser,
    (state: UserState) => state.profile
);

export const getAlert = createSelector(
    selectUser,
    (state: UserState) => state.alert
);

export const getSinalization = createSelector(
    selectUser,
    (state: UserState) => state.sinalization
);

export const getNotification = createSelector(
    selectUser,
    (state: UserState) => state.notification
);

export const getNotificationCounter = createSelector(
    selectUser,
    (state: UserState) => state.notificationCounter
);

export const getNotificationAlerts = createSelector(
    getNotification,
    getAlert,
    (notifications, alerts) => {
        const alertList: Alert[] = [];
        if (notifications.length && alerts.length) {
            notifications.forEach(notification => {
                const alert = alerts.find(alertData => alertData.aid === notification.alert.aid);

                if (alert) {
                    const tmpAlert = {...alert};
                    tmpAlert.cd = notification.cd;

                    if (!tmpAlert.notifications) {
                        tmpAlert.notifications = [];
                    }
                    tmpAlert.notifications.push(notification);

                    alertList.push(tmpAlert);
                }
            });
        }

        return alertList;
    }
  );

export const getFavorite = createSelector(
    selectUser,
    (state: UserState) => state.favorite
);

export const hideOnboarding = createSelector(
    selectUser,
    (state: UserState) => state.hideOnboarding
);

export type ListStatus = 'loading' | 'empty' | 'ready';

// Distinguishes "not loaded yet" from "no results", so the empty message is not shown while loading
const listStatus = (loaded: boolean, items: unknown[]): ListStatus =>
    !loaded ? 'loading' : (items?.length ? 'ready' : 'empty');

const selectLoaded = createSelector(selectUser, (state: UserState) => state.loaded);

export const getFavoritesStatus = createSelector(
    selectLoaded,
    getFavoriteMarkets,
    (loaded, markets) => listStatus(loaded?.favorite, markets)
);

export const getAlertsStatus = createSelector(
    selectLoaded,
    getAlert,
    (loaded, alerts) => listStatus(loaded?.alert, alerts)
);

export const getNotificationAlertsStatus = createSelector(
    selectLoaded,
    getNotificationAlerts,
    (loaded, alerts) => listStatus(loaded?.alert && loaded?.notification, alerts)
);

export const getSinalizationStatus = createSelector(
    selectLoaded,
    getSinalization,
    (loaded, sinalizations) => listStatus(loaded?.sinalization, sinalizations)
);
